import React from "react";
import { Badge } from "react-bootstrap";
import {
  FaCalendarCheck, FaInfoCircle, FaGlobe
} from "react-icons/fa";
import GenericCrudPage from '../components/GenericCrudPage'; // Assuming this path is correct

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation for Programme Year form
const validateProgrammeYearForm = (form) => {
  const errors = {};
  if (!form.exName.trim()) errors.exName = "Programme Year Name is required";
  if (form.exName.length > 100) errors.exName = "Programme Year Name must be less than 100 characters";
  return errors;
};

// Configuration for Programme Year CRUD operations
const programmeYearConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getProgrammeYear',
    save: '/master/saveProgrammeYear',
    update: '/master/updateProgrammeYear',
    delete: '/master/deleteProgrammeYear'
  },
  validateForm: validateProgrammeYearForm,
  initialFormState: {
    exName: "", exDescription: "", exLocalLangName: "", exIsActive: 1, user: ""
  },
  entityName: 'Programme Year'
};

// Form fields configuration
const formFields = [
  { name: "exName", label: "Programme Year Name", icon: FaCalendarCheck, required: true },
  { name: "exLocalLangName", label: "Local Language Name", icon: FaGlobe },
  { name: "exDescription", label: "Description", icon: FaInfoCircle, as: "textarea", rows: 3, md: 12, lg: 8 }, // Full width for description
];

// Table columns configuration
const tableColumns = [
  {
    key: 'exName',
    label: 'Programme Year Name',
    sortable: true,
    render: (programmeYear) => (
      <div className="fw-bold">{programmeYear.exName}</div>
    )
  },
  { key: 'exLocalLangName', label: 'Local Name', sortable: true, render: (programmeYear) => programmeYear.exLocalLangName || 'No local name' },
  { key: 'exDescription', label: 'Description', sortable: true, className: "text-truncate", style: { maxWidth: '250px' } }
];

// CSV export headers
const csvHeaders = [
  { key: 'exName', label: 'Programme Year Name' },
  { key: 'exDescription', label: 'Description' },
  { key: 'exLocalLangName', label: 'Local Language Name' },
  { key: 'exIsActive', label: 'Status', formatter: (value) => (value ? "Active" : "Inactive") }
];

// Transform form data to API payload
// The userId is passed from GenericCrudPage
const transformPayload = (form, editId, userId) => ({
  exName: form.exName.trim(),
  exDescription: form.exDescription.trim(),
  exLocalLangName: form.exLocalLangName.trim(),
  exIsActive: form.exIsActive,
  user: userId, // Ensure user is passed
  ...(editId && { id: editId })
});

// Transform API data to form
const transformToForm = (programmeYear) => ({
  exName: programmeYear.exName || "",
  exDescription: programmeYear.exDescription || "",
  exLocalLangName: programmeYear.exLocalLangName || "",
  exIsActive: programmeYear.exIsActive,
  user: programmeYear.user || "", // User ID from fetched data
});

// Get view modal fields
const getViewFields = (programmeYear) => {
  if (!programmeYear) return [];
  return [
    { label: "Programme Year Name", value: programmeYear.exName, icon: FaCalendarCheck },
    { label: "Local Language Name", value: programmeYear.exLocalLangName, icon: FaGlobe },
    { label: "Description", value: programmeYear.exDescription, icon: FaInfoCircle, fullWidth: true },
  ];
};

export default function ProgrammeYearPage() {
  return (
    <GenericCrudPage
      title="Programme Years" // This will be the header text for the page
      config={programmeYearConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaCalendarCheck}
      searchPlaceholder="Search by name, description, local language..."
      csvHeaders={csvHeaders}
      csvFilename="programme_years_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
    />
  );
}